export interface PlgAgentFeatureCheckRequest {
    task_id: string;
}

export interface PlgAgentFeatureCheckResponse {
    can_use: boolean;
}

export interface PlgAgentFeatureCheckApi {
    checkPlgAgentFeature(params: PlgAgentFeatureCheckRequest): Promise<PlgAgentFeatureCheckResponse>;
}

export const PlgAgentFeatureCheckApi = Symbol.for('PlgAgentFeatureCheckApi');
